/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { screen } from "@eisinc/XDL/Helpers";
import modal from "@eisinc/XDL/PreStyle/modal";
import { findLocationModalStyles } from "@insite/content-library/Components/FindLocationModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";


findLocationModalStyles.centeringWrapper = {};

findLocationModalStyles.modal = {
    ...modal,
    sizeVariant: "large",
};

findLocationModalStyles.searchGridContainer = {
    css: css``,
};

findLocationModalStyles.searchResultsTextGridItem = {
    width: 12,
    css: css``,
};

findLocationModalStyles.searchResultsTextGridItem = {
    width: 4,
    align: "middle",
    css: css``,
};

findLocationModalStyles.distanceUnitOfMeasureGridItem = {
    width: 8,
    align: "middle",
    css: css``,
};

findLocationModalStyles.distanceUnitOfMeasureRadioGroup = {
    css: css`
        display: inline-block;
        width: 100%;
        flex-direction: row;
        text-align: right;
        & > div {
            display: inline-flex;
            label {
                margin-right: 22px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                margin-right: 22px;
                            `,
                        ],
                        "max",
                    )}
            }
        }
        > div:last-child {
            > label {
                margin-right: 0 !important;
            }
        }
        > div:first-child {
            > label {
                ${screen("lte", "sm")`
                    margin-right: 20px !important;
                `}
            }
        }
    `,
};

findLocationModalStyles.searchButton = {
    css: css`
        width: 100%;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                width: 25%
                `,
                css`
                width: 25%
                `,
                null,
                null,
            ])}
    `,
};

findLocationModalStyles.searchResultLeftGridItem = {
    width: [12, 9, 9, 9, 9],
};
findLocationModalStyles.searchResultSelectGridItem = {
    width: [12, 3, 3, 3, 3],
    css: css`
        ${screen("lte", "xs")`
            order: 3;
        `}
    `,
};

findLocationModalStyles.searchResultLinksAndDistanceContainer = {
    gap: 6,
};

findLocationModalStyles.searchResultSelectButton = {
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};
findLocationModalStyles.searchResultWarehouseDetailsGridContainer = {
    gap: 6,
};
findLocationModalStyles.searchResultDisplayNumberGridItem = {
    width: 1,
    css: css`
        justify-content: flex-start;
    `,
};
findLocationModalStyles.searchResultWarehouseGridItem = {
    width: 11,
};
findLocationModalStyles.warehouseDisplayNumberText = {
    color: "primary",
    weight: "normal",
};
findLocationModalStyles.warehouseNameText = {
    color: "text.main",
    weight: "bold",
    ellipsis: true,
};
findLocationModalStyles.searchResultAddressInfoOffsetGridItem = {
    width: 1,
    css: css`
        justify-content: flex-start;
    `,
};
findLocationModalStyles.searchResultAddressInfoGridItem = {
    width: 11,
    css: css`
        &,
        * {
            font-size: 14px;
            line-height: 18px;
        }
    `,
};
findLocationModalStyles.searchResultPhoneOffsetGridItem = {
    width: 1,
    css: css`
        justify-content: flex-start;
    `,
};
findLocationModalStyles.searchResultPhoneGridItem = {
    width: 11,
    css: css`
        align-items: center;
    `,
};

findLocationModalStyles.searchResultPhoneLink = {
    css: css`
        * {
            font-size: 14px;
            line-height: 16px;
        }
    `,
};
findLocationModalStyles.searchResultPhoneIcon = {
    color: "primary",
    css: css`
        svg {
            width: 16px;
            height: 16px;
        }
    `,
};
findLocationModalStyles.searchResultAddressInfoIcon = {
    color: "primary",
    css: css`
        svg {
            width: 16px;
            height: 16px;
        }
    `,
};
findLocationModalStyles.searchResultLinksOffsetGridItem = {
    width: [0, 2, 2, 2, 2],
};

findLocationModalStyles.searchResultHoursGridItem = {
    width: 3,
    css: css`
        * {
            font-size: 14px;
            line-height: 16px;
        }
    `,
};
findLocationModalStyles.searchResultGoogleMapsDirectionLinkGridItem = {
    width: 3,
    css: css`
        * {
            font-size: 14px;
            line-height: 16px;
        }
    `,
};
findLocationModalStyles.searchResultDistanceGridItem = {
    width: 5,
    css: css`
        * {
            font-size: 14px;
            line-height: 16px;
        }
        ${screen("lt", "sm")`
            justify-content: center;
        `}
    `,
};
findLocationModalStyles.searchResultDividerGridItem = {
    width: 0,
};
findLocationModalStyles.searchResultGridItem = {
    width: 12,
    css: css`
        padding-top: 0;
        > div {
            border-top: 1px solid ${getColor("common.ui4")};
            padding-top: 15px;
            width: calc(100% + 15px);
        }
    `,
};
findLocationModalStyles.searchResultGridContainer = {
    gap: 15,
    css: css`
        padding-top: 0;
        > div {
            width: calc(100% + 15px);
        }
    `,
};
findLocationModalStyles.currentlySelectedHeaderGridItem = {
    width: 12,
    css: css`
        padding-bottom: 0;
    `,
};
findLocationModalStyles.currentlySelectedHeaderText = {
    weight: "bold",
    css: css`
        line-height: 18px;
        font-size: 14px;
    `,
};
findLocationModalStyles.currentlySelectedDetailsGridItem = {
    width: 12,
    css: css`
        padding-top: 7px;
    `,
};
findLocationModalStyles.selectedWarehousePhoneLink = {
    css: css`
        * {
            font-size: 14px;
            line-height: 16px;
        }
    `,
};
findLocationModalStyles.selectedWarehouseDetailsGridItem = {
    width: [8, 6, 6, 6, 6],
    css: css`
        * {
            font-size: 15px;
            line-height: 20px;
        }
        flex-direction: column;
    `,
};
findLocationModalStyles.selectedWarehouseLinksGridItem = {
    width: [4, 6, 6, 6, 6],
    css: css`
        flex-direction: column;
    `,
};
findLocationModalStyles.selectedWarehouseLink = {
    css: css`
        * {
            font-size: 15px;
            line-height: 16px;
        }
    `,
};
findLocationModalStyles.selectedWarehouseGoogleMapsDirectionLink = {
    css: css`
        * {
            font-size: 15px;
            line-height: 18px;
        }
    `,
};
findLocationModalStyles.selectedWarehouseDistanceText = {
    css: css`
        * {
            font-size: 15px;
            line-height: 18px;
        }
    `,
};
findLocationModalStyles.selectedWarehouseNameText = {
    color: "primary",
    weight: "bold",
    css: css`
        font-size: 18px !important;
        line-height: 26px !important;
    `,
};
findLocationModalStyles.paginationGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};
findLocationModalStyles.centeringWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};
